import instance from "services/api";

const safeGet = (url) =>
  instance(false)
    .get(url)
    .then((res) => res?.data || [])
    .catch(() => []);

export const getPublications = (params) =>
  safeGet(`/alem/getPublications?${params}`);

export const getSentiment = () => safeGet(`/alem/sentiment`);

export const getTopics = () => safeGet(`/alem/topic`);

export const getSentimentData = (params) =>
  safeGet(`/alem/sentimentStats?${params}`);

export const getAuthorStats = (params) =>
  safeGet(`/alem/authorStats?${params}`);

export const getResource = (params) => safeGet(`/alem/resourceStats?${params}`);

export const getLanguage = (params) => safeGet(`/alem/languageStats?${params}`);

export const getSentimentResourceStats = (params) =>
  safeGet(`/alem/sentimentResourceStats?${params}`);

// AQ-290: лента новостей СМИ. Важно: даты в формате "YYYY-MM-DD HH:mm:ss"
// (с пробелом, не T) — иначе бэкенд отвечает 400. Пагинация: page (с 0) + size.
export const getWorldNews = (params) => safeGet(`/worldnews?${params}`);
